import ApiServices, {ADD_ORDER_EXPORT_ONCE_TASK, ADD_ORDER_EXPORT_REPEAT_TASK} from "../config/ApiServices";
import api from "../utils/api";

export class AddOnceCustomOrderExportTaskEvent {
    params = null;
    constructor(params?: any) {
        this.params = params || {};
    }

    static getEventName() {
        return 'AddOnceCustomOrderExportTaskEvent';
    }
}


export class AddOnceCustomOrderExportTaskEventListener {
    dispatcher;

    constructor(dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle(event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[ADD_ORDER_EXPORT_ONCE_TASK], event.params);
        if (res['status']) {
            return res;
        }
    }

    async after(event) {

    }
}


export class AddRepeatCustomOrderExportTaskEvent {
    params = null;
    constructor(params?: any) {
        this.params = params || {};
    }

    static getEventName() {
        return 'AddRepeatCustomOrderExportTaskEvent';
    }
}


export class AddRepeatCustomOrderExportTaskEventListener {
    dispatcher;

    constructor(dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle(event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[ADD_ORDER_EXPORT_REPEAT_TASK], event.params);
        if (res['status']) {
            return res;
        }else{
            return false;
        }
    }

    async after(event) {

    }
}